const fileStatusConfig = {
    requested: {
        sortOrder: 1,
        text: 'Angefragt',
        color: 'grey-3',
        textColor: 'primary',
    },
    uploaded: {
        sortOrder: 2,
        text: 'Hochgeladen',
        color: 'grey-3',
        textColor: 'primary',
    },
    ready: {
        sortOrder: 3,
        text: 'Bereit',
        color: 'grey-3',
        textColor: 'positive',
    },
    verified: {
        sortOrder: 4,
        text: 'Geprüft',
        color: 'grey-3',
        textColor: 'positive',
    },
    processed: {
        sortOrder: 5,
        text: 'Verarbeitet',
        color: 'grey-3',
        textColor: 'positive',
    },
    archived: {
        sortOrder: 6,
        text: 'Archiviert',
        color: 'grey-3',
        textColor: 'positive',
    },
    problem: {
        sortOrder: 7,
        text: 'Klärung',
        color: 'grey-3',
        textColor: 'negative',
    },
};

export default fileStatusConfig;
